(function () {
    var burger = document.querySelector('.mith-nav-burger');
    var nav = document.getElementById('gh-navigation');
    if (!burger || !nav) {
        return;
    }

    burger.addEventListener('click', function () {
        var isOpen = burger.getAttribute('aria-expanded') === 'true';
        burger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        document.body.classList.toggle('is-nav-open', !isOpen);
    });

    var links = nav.querySelectorAll('.mith-nav-menu a');
    for (var i = 0; i < links.length; i++) {
        links[i].addEventListener('click', function () {
            burger.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('is-nav-open');
        });
    }
}());
